module.exports = __webpack_public_path__ + "static/media/yz_color.af23b091.webp";